<template>
  <pt-save-sign-table class="pt-save-sign-table__withData" @getTableData="getTableData" :totalNumber="totalNumber"
  :tableData="tableData" :pageSize="pageSize" ref="table" :isOutside="isOutside">
  <slot/>
  </pt-save-sign-table>
</template>

<script>
import PtSaveSignTable from './index'
export default {
  name: 'pt-save-sign-table__withData',
  components: {
    'pt-save-sign-table': PtSaveSignTable
  },
  props: {
    paramsData: {
      type: Object
    },
    isFromRouter: {
      type: Boolean
    }
  },
  watch: {
    paramsData: {
      handler: function (val) {
        if (this.isFromRouter) {
        //   this.getTableData(0)
          this.isOutside = true
          this.getTableData(this.page)
        } else {
          this.resetPage()
        }
      }
    }
  },
  data () {
    return {
      totalNumber: null,
      tableData: [],
      pageSize: 10,
      signId: null,
      loading: false,
      isOutside: false
    }
  },
  methods: {
    resetPage () {
      this.$refs.table.resetPage()
    },
    async getTableData (page, next) {
      let data = {
        pageableParam: {
          page: page,
          size: this.pageSize
        },
        ...this.paramsData,
        type: 'STORAGE'
      }
      if (!next) {
        this.loading = true
      }
      this.$store.dispatch('getSignList', data).then(res => {
        this.totalNumber = res.totalNumber
        this.tableData = res.data
        if (next) {
          next(res.data)
        } else {
          this.loading = false
        }
      }).catch(err => {
        this.loading = false
        this.$refs.table.showReTry()
        this.$message.error(err || '获取存储报名失败')
      })
      // let signMessage = await this.$store.dispatch('getSignList', data)
      // this.signId = signMessage.data && signMessage.data[0] && signMessage.data[0].id
      // let dataNotes = {
      //   mallRegistrationId: this.signId,
      //   pageableParam: {
      //     page: page,
      //     size: this.pageSize
      //   },
      //   ...this.paramsData
      // }
      // this.$store.dispatch('getSignNotes', dataNotes).then(res => {
      //   this.totalNumber = res.totalNumber
      //   this.tableData = res.data
      //   if (next) {
      //     next(res.data)
      //   } else {
      //     this.loading = false
      //   }
      // }).catch(err => {
      //   this.loading = false
      //   this.$refs.table.showReTry()
      //   this.$message.error(err || '获取活动报名记录失败')
      // })
    }
  }
}
</script>
